import { Image } from 'antd-mobile';
import img from 'app/img';

export function MoeCounter() {
  return (
    <div style={{ padding: 10, width: 200 }}>
      <Image src="https://count.getloli.com/get/@:name?theme=moebooru-h" />
    </div>
  );
}
